import { API_ROOT_URL, SearchParameters } from '..'
import { PaginationAndSortingValues } from '../../components/moovyPagination'

import { client } from '../moovyAxiosClient'
import { CreateWhitelistedVehicleDTO, WhitelistResponseDTO } from './dto'

const BASE_URL = `${API_ROOT_URL}/whitelist`

const getWhitelist = (params: {
  paginationAndSorting: PaginationAndSortingValues
  searchParameters: SearchParameters
}) => {
  const { paginationAndSorting, searchParameters } = params
  return client.get<WhitelistResponseDTO>(BASE_URL, {
    params: { ...paginationAndSorting, ...searchParameters },
  })
}

const getWhitelistedVehicle = (id: string) => {
  return client.get<WhitelistResponseDTO>(`${BASE_URL}/${id}`)
}

const createWhitelistedVehicle = (data: CreateWhitelistedVehicleDTO) => {
  return client.post<WhitelistResponseDTO>(BASE_URL, data)
}

const deleteWhitelistedVehicle = (parameters: {
  id: string
  comment: string
}) => {
  const { id, comment } = parameters
  return client.delete<WhitelistResponseDTO>(`${BASE_URL}/${id}/delete`, {
    params: { comment },
  })
}

const updateWhitelistedVehicle = (parameters: {
  vehicleData: CreateWhitelistedVehicleDTO
  id: string
  comment: string
}) => {
  const { vehicleData, id, comment } = parameters
  return client.put<WhitelistResponseDTO>(`${BASE_URL}/${id}`, {
    name: vehicleData.name,
    comment,
  })
}

export const WhitelistApi = {
  getWhitelist,
  getWhitelistedVehicle,
  createWhitelistedVehicle,
  deleteWhitelistedVehicle,
  updateWhitelistedVehicle,
}
